import { useLeadSourcesSettingsLocation } from "components/manage/lead-sources-settings/use-lead-sources-settings-location";
import { Spinner } from "components/ui/spinner";
import React from "react";
import { Redirect } from "react-router";
import { AgencySettings } from "./agency-settings";

export const AgencyLeadSourcesRoute: React.FC<unknown> = () => {
    const leadSourcesLocation = useLeadSourcesSettingsLocation();
    switch (leadSourcesLocation) {
        case "loading":
            return <Spinner />;
        case "office":
            return <Redirect to="/settings/region/lead-sources" />;
        case "agency":
            return <AgencySettings />;
    }
    const exhaustiveCheck: never = leadSourcesLocation;
    throw new Error(`Unhandled lead sources settings location: ${exhaustiveCheck}`);
};
